import React from 'react';
import Blink from 'react-blink-text';

const TextSmall = ({
    children = '',
    color = "black",
    blink = false,
    textAlign = "unset",
    fontSize = "12px",
    wordBreak = "break-word",
    fontWeight = "normal",
}) => {

    const styles = {
        text: {
            fontFamily: "verdana",
            fontSize: fontSize,
            color: color,
            textAlign: textAlign,
            wordBreak: wordBreak,
            fontWeight: fontWeight,
        }
    };

    if (!blink) {
        return (
            <div style={styles.text}>
                {children}
            </div>
        )
    }
    else {
        return (
            <div style={styles.text}>
                <Blink color={color} text={children} fontSize={fontSize}>
                </Blink>
            </div>
        );
    }

};

export default TextSmall;
